import useAxiosInterceptor from 'src/services/interceptor';
class MonthlyCloseoutService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getMonthlyCloseOut = (payload: any) => {
    return this.axiosInstance.get(`/provider/month-end-alert/closeout`, {
      params: payload?.param,
    });
  };

  uploadSignatureFile = (payload: any) => {
    return this.axiosInstance.post(
      '/provider/month-end-alert/closeout/consent-upload',
      payload?.data,
      {
        params: payload?.param,
      }
    );
  };
}

const monthlyCloseoutService = new MonthlyCloseoutService();

Object.freeze(monthlyCloseoutService);

export default monthlyCloseoutService;
